
import Footer from '../../components/Footer/Footer'
import './Privacy.css'

export default function Privacy() {
    return (
        <>
            <div className="privacyContainer">
                <h1>Политика обработки персональных данных</h1>

                <h3>1. Общие положения</h3>
                <p>Настоящая политика обработки персональных данных разработана в соответствии с требованиями Федеральный закон №152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных.</p>
                <p>Оператором персональных данных является: <br/>ООО «ЦИТ Нейросфера » &nbsp; <br/> Email: info@cit-neurosfera.ru</p>

                <h3>2. Персональные данные, которые обрабатываются</h3>
                <p>Оператор может обрабатывать следующие персональные данные пользователей:</p>
                <ol>
                    <li>фамилия, имя, отчество;</li>
                    <li>адрес электронной почты;</li>
                    <li>номер телефона;</li>
                    <li>иные данные, предоставленные пользователем через формы сайта;</li>
                    <li>IP-адрес;</li>
                    <li>данные файлов cookie;</li>
                    <li>информация о браузере, устройстве и действиях пользователя на сайте.</li>
                </ol>

                <h3>3. Цели обработки персональных данных</h3>
                <p>Персональные данные обрабатываются в следующих целях:</p>
                <ol>
                    <li>установление обратной связи с пользователем;</li>
                    <li>обработка запросов и заявок;</li>
                    <li>предоставление услуг и выполнение обязательств перед пользователем;</li>
                    <li>улучшение качества работы сайта;</li>
                    <li>проведение аналитики и статистических исследований.</li>
                </ol>

                <h3>4. Правовые основания обработки</h3>
                <p>Обработка персональных данных осуществляется на основании:</p>
                <ol>
                    <li>согласия субъекта персональных данных;</li>
                    <li>исполнения договора или предварительных договорных обязательств;</li>
                    <li>требований законодательства Российской Федерации.</li>
                </ol>

                <h3>5. Условия обработки и хранения персональных данных</h3>
                <p>Персональные данные обрабатываются с соблюдением принципов и правил, предусмотренных законодательством РФ.</p>
                <p>Обработка осуществляется с использованием автоматизированных и неавтоматизированных средств.</p>
                <p>Срок хранения персональных данных определяется целями обработки, если иной срок не установлен законодательством.</p>
                <p>Персональные данные граждан Российской Федерации хранятся на территории Российской Федерации.</p>

                <h3>6. Передача персональных данных третьим лицам</h3>
                <p>Оператор вправе передавать персональные данные третьим лицам в следующих случаях:</p>
                <ol>
                    <li>при использовании сервисов веб-аналитики (в том числе Яндекс.Метрика );</li>
                    <li>при исполнении обязательств перед пользователем;</li>
                    <li>по требованию законодательства.</li>
                </ol>
                <p>При использовании сервиса Яндекс.Метрика данные могут передаваться компании Яндекс в соответствии с её политикой конфиденциальности.</p>

                <h3>7. Использование файлов cookie и аналитики</h3>
                <p>Сайт использует файлы cookie и сервис веб-аналитики Яндекс.Метрика .</p>
                <p>Собираемая информация может включать:</p>
                <ol>
                    <li>IP-адрес;</li>
                    <li>данные о поведении пользователя на сайте;</li>
                    <li>технические характеристики устройства и браузера.</li>
                </ol>
                <p>Пользователь может отключить cookie в настройках своего браузера.</p>

                <h3>8. Права субъекта персональных данных</h3>
                <p>Пользователь имеет право:</p>
                <ol>
                    <li>получать информацию о своих персональных данных;</li>
                    <li>требовать их уточнения, блокирования или удаления;</li>
                    <li>отозвать согласие на обработку персональных данных;</li>
                    <li>направлять обращения оператору.</li>
                </ol>

                <h3>9. Меры защиты персональных данных</h3>
                <p>Оператор принимает необходимые организационные и технические меры для защиты персональных данных от неправомерного доступа, изменения, раскрытия или уничтожения.</p>

                <h3>10. Заключительные положения</h3>
                <p>Оператор вправе вносить изменения в настоящую политику без предварительного уведомления.</p>
                <p>Актуальная версия политики всегда доступна на сайте.</p>


            </div>
            <Footer />
        </>
    )
}
